module.exports = __webpack_public_path__ + "img/bannerproduct.3733469e.png";